<div class="error" [ngSwitch]="errorType">

  <img class="error__logo" src="assets/images/biodigital-logo.svg">
  
  <ng-container *ngSwitchCase="'content'">
  
    <div class="error__text">
      <div>Our apologies.</div>
      <div>We're unable to find the model you are looking for.</div>
    </div>
  
    <p class="error__subtext">404 Error. Content not found.</p>
  
  </ng-container>
  
  <ng-container *ngSwitchDefault>
  
    <div class="error__text">
      <div>Our apologies.</div>
      <div>We're unable to find the page you are looking for.</div>
    </div>
  
    <p class="error__subtext">404 Error. Page not found.</p>

  </ng-container>

  <button
    class="error__button"
    [routerLink]="['/dashboard']">
    Go to Dashboard
  </button>

</div>
